import React from "react";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../react-core/Html/PartLoading";
import { AlertTriggerInfo } from "../../../../../../Wrap/Models/Domains/Threads/AlertTriggerInfo";
import { NotificationAction } from "../../Action/NotificationAction";
import { AlertDefinition } from "../../../../../Shared/Entities/Constants/AlertDefinition";

interface INotificationsExplainedProps {}

interface INotificationsExplainedState {
    triggerInfo: Array<AlertTriggerInfo>;
}

export class NotificationsExplained extends FormComponent<INotificationsExplainedProps, INotificationsExplainedState> {
    constructor(props: INotificationsExplainedProps) {
        super(props);
        this.state = {
            triggerInfo: [],
        };
    }

    componentDidMount() {
        this.getTriggerInfo();
    }

    private filterResult(result: Array<AlertTriggerInfo>) {
        return result.filter((x) => x.AlertDefinitionId != AlertDefinition.MifidValueDrop);
    }

    private getTriggerInfo() {
        NotificationAction.getTriggerInformation((result) => {
            result = this.filterResult(result);
            this.setState({ triggerInfo: result });
        });
    }

    private renderTriggerInformation() {
        const { triggerInfo } = this.state;
        if (triggerInfo.length == 0) {
            return <PartLoading isLoading={true} />;
        }
        const descriptions = [];
        triggerInfo.sort((a, b) => a.AlertDefinitionName.localeCompare(b.AlertDefinitionName));
        triggerInfo.forEach((info) => {
            descriptions.push(
                <p>
                    <strong>{info?.AlertDefinitionName}</strong>
                    <br />
                    {info?.TriggerInformation}
                </p>
            );
        });
        return descriptions;
    }

    render() {
        return <>{this.renderTriggerInformation()}</>;
    }
}
